import axios from 'axios';
import { Toast } from 'vant';
import store from '../store';
import router from '../router';
const testApi = "http://testyyjj-serviceapi.yiyuanjianji.com/";
// const testApi = "http://172.16.35.164:20410";

const api = "https://yyjj-serviceapi.yiyuanjianji.com/";

const axiosInstance = axios.create({
  baseURL: getBaseUrl(),
});

function getBaseUrl() {
  let env = process.env.NODE_ENV;
  if (env === "production") {
    return api;
  } else {
    return testApi;
    // return api;

  }
}

const request = {
  GET({ url, params, success, fail }) {
    Toast.loading();
    axiosInstance
      .get(url, {
        params: params,
        headers: this.getHeader(),
      })
      .then((res) => {
        Toast.clear();
        this.then(res.data, success, fail);
      })
      .catch((err) => {
        Toast.clear();
        fail && fail("网络异常");
      });
  },
  
  POST({ url, data, success, fail , showLoading=true}) {
    if(showLoading){
      Toast.loading();
    }
    axiosInstance
      .post(url, data, {
        headers: this.getHeader(),
      })
      .then((res) => {
        Toast.clear();
        this.then(res.data, success, fail);
      })
      .catch((err) => {
        Toast.clear();
        Toast("请求异常");
        fail && fail("请求异常");
      });
  },

  then(res, success, fail) {
    if (res.resultCode !== "200") {
      Toast(res.msg ? res.msg : "请求异常");

      if(res.resultCode=="1004"){
        store.commit("clear")
        localStorage.removeItem("appId")
        localStorage.removeItem("token")
        router.push({name:"login"})
      }

      fail && fail(res.msg);
    }
    else {
      success && success(res.obj);
    }
  },

getHeader() {
    return {
      "appId": store.state.appId,
      "token": store.state.token,
    };
  },
};

export default request;
